export default __webpack_public_path__ + "static/media/mp.0c771c14.svg";